import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppStore } from "./AppStore";
import { Sprout, HeartHandshake, Home as HomeIcon, X, Repeat, Store } from "lucide-react";

const ROLES = [
  { key: "kid", label: "Do'er (Kid)", desc: "Browse & accept neighborhood jobs", to: "/home", icon: Sprout, tint: "#3b57c9" },
  { key: "parent", label: "Parent", desc: "Approve jobs & accept liability", to: "/parent", icon: HeartHandshake, tint: "#4fae3f" },
  { key: "neighbor", label: "Neighbor (Poster)", desc: "Post jobs for kids to complete", to: "/neighbor", icon: Store, tint: "#f5911e" },
];

export default function RoleSwitcher() {
  const [open, setOpen] = useState(false);
  const { viewAs, setViewAs, pendingApprovalCount } = useAppStore();
  const navigate = useNavigate();
  const active = ROLES.find((r) => r.key === viewAs) || ROLES[0];

  const pick = (r) => {
    setViewAs(r.key);
    setOpen(false);
    navigate(r.to);
  };

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="gd-tap absolute z-40 flex items-center gap-1.5 rounded-full px-3 py-2 text-[11px] font-extrabold text-white shadow-lg"
        style={{ right: 12, bottom: 96, background: "linear-gradient(180deg,#3f5ccb,#2f47a8)", border: "2px solid rgba(255,255,255,.25)" }}
      >
        <Repeat size={14} /> View: {active.label.split(" ")[0]}
        {viewAs === "parent" && pendingApprovalCount > 0 && (
          <span className="ml-0.5 grid h-4 min-w-4 place-items-center rounded-full bg-[#e0533d] px-1 text-[9px]">{pendingApprovalCount}</span>
        )}
      </button>

      {open && (
        <div className="absolute inset-0 z-50 flex items-end bg-black/40" onClick={() => setOpen(false)}>
          <div className="gd-enter w-full rounded-t-[28px] bg-white p-6 pb-8" onClick={(e) => e.stopPropagation()}>
            <div className="mx-auto mb-4 h-1.5 w-12 rounded-full bg-[#e6e9f5]" />
            <div className="flex items-center justify-between">
              <div>
                <h3 className="text-lg font-black text-[#1f2a52]">Demo: Switch Perspective</h3>
                <p className="text-xs font-semibold text-[#9aa3c0]">See how the three roles sync together</p>
              </div>
              <button onClick={() => setOpen(false)} className="text-[#a3abc9]"><X size={20} /></button>
            </div>
            <div className="mt-4 space-y-2.5">
              {ROLES.map((r) => (
                <button key={r.key} onClick={() => pick(r)}
                  className="gd-tap flex w-full items-center gap-3 rounded-2xl border-2 p-3 text-left transition-all"
                  style={{ borderColor: viewAs === r.key ? r.tint : "#eef1fb", background: viewAs === r.key ? `${r.tint}10` : "#fff" }}>
                  <div className="grid h-11 w-11 flex-shrink-0 place-items-center rounded-2xl" style={{ background: `${r.tint}18` }}>
                    <r.icon size={20} color={r.tint} />
                  </div>
                  <div className="flex-1">
                    <p className="text-sm font-extrabold text-[#1f2a52]">{r.label}</p>
                    <p className="text-[11px] font-semibold text-[#9aa3c0]">{r.desc}</p>
                  </div>
                  {r.key === "parent" && pendingApprovalCount > 0 && (
                    <span className="rounded-full bg-[#fdece0] px-2 py-0.5 text-[10px] font-bold text-[#e97f0c]">{pendingApprovalCount} pending</span>
                  )}
                  {viewAs === r.key && <span className="text-[10px] font-bold" style={{ color: r.tint }}>Active</span>}
                </button>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
